<template>
  <div class="body">
    <!--    <divider/>-->
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">名称</td>
          <td class="tdContent">{{ productions.productName }}</td>
          <td class="tableLabel">客户名称</td>
          <td class="tdContent">{{ productions.customerName }}</td>
          <td class="tableLabel">客户编号</td>
          <td class="tdContent">{{ productions.customerNo }}</td>
          <td class="tableLabel">客户等级</td>
          <td class="tdContent">
            {{ constant.customerLevel[productions.customerLevel] }}
            <!--            <el-select v-model="productions.customerLevel" :disabled="true" style="width: 80px;">-->
            <!--              <el-option v-for="item in customerLevels" :key="item.value" :label="item.label" :value="item.value"/>-->
            <!--            </el-select>-->
          </td>
        </tr>
        <tr>
          <td class="tableLabel">产品类型</td>
          <td class="tdContent">
            {{ constant.productCategory[productions.productCategory] }}
            <!--            <el-select v-model="productions.productCategory" style="width: 140px;" :disabled="true">-->
            <!--              <el-option :value="10" label="滤波器"/>-->
            <!--              <el-option :value="20" label="变压器"/>-->
            <!--              <el-option :value="30" label="解谐电抗器"/>-->
            <!--              <el-option :value="40" label="电抗器"/>-->
            <!--              <el-option :value="50" label="电阻"/>-->
            <!--              <el-option :value="60" label="高频电感"/>-->
            <!--            </el-select>-->
          </td>
          <td class="tableLabel">交货部门</td>
          <td class="tdContent">{{ productions.materialTypeName }}</td>
          <td class="tableLabel">产品规格</td>
          <td class="tdContent">{{ productions.specificationType }}</td>
          <td class="tableLabel">制单时间</td>
          <td class="tdContent">{{ productions.createTime }}</td>
        </tr>
        <tr>
          <td class="tableLabel">产品代码</td>
          <td class="tdContent" colspan="3">{{ productions.productCode }}</td>
          <td class="tableLabel">预计用量</td>
          <td class="tdContent" colspan="3">{{ productions.preOrderQty }}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="8">{{ productions.note }}</td>
        </tr>
        <tr>
          <td class="tableLabel">项目类型</td>
          <td class="tdContent" colspan="8">
            <div style="display: flex;">
              <div v-if="disableApplicationType">
                {{ constant.productApplicationType[productions.applicationType] }}
              </div>
              <div v-else>
                <el-select v-model="productions.applicationType" style="width: 100px;">
                  <el-option :value="20" label="项目Ⅰ"/>
                  <el-option :value="10" label="项目Ⅱ"/>
                </el-select>
              </div>
              <div v-if="disableApplicationType" style="margin-left: 10px;">
                {{ productions.applicationSubType }}
              </div>
              <div v-else>
                <el-checkbox-group v-model="subTypeList" style="margin-left: 20px;" :disabled="disableApplicationType"
                                   @change="changeSubType()" :max="1">
                  <el-checkbox label="Y"/>
                  <el-checkbox label="H"/>
                  <el-checkbox label="W"/>
                  <el-checkbox label="D"/>
                </el-checkbox-group>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="showCostPrice">
          <td class="tableLabel">材料价</td>
          <td class="tdContent">
            <el-input type="number" v-model="productions.materialCost" style="width: 120px;"
                      :disabled="disableCostPrice"
                      @input="productions.materialCost = String(productions.materialCost).replace(/[^\d.]/g, '')"/>
          </td>
          <td class="tableLabel">人工成本</td>
          <td class="tdContent">
            <el-input type="number" v-model="productions.manualCost" style="width: 120px;" :disabled="disableCostPrice"
                      @input="productions.manualCost = String(productions.manualCost).replace(/[^\d.]/g, '')"/>
          </td>
          <td class="tableLabel">出厂价</td>
          <td class="tdContent" colspan="4">
            <el-input type="number" v-model="productions.productCost" style="width: 120px;" :disabled="disableCostPrice"
                      @input="productions.productCost = String(productions.productCost).replace(/[^\d.]/g, '')"/>
          </td>
        </tr>
        <tr v-if="showCostPrice">
          <td class="tableLabel">方案</td>
          <td class="tdContent" colspan="8">
            <el-input type="textarea" v-model="productions.solution" :disabled="disableCostPrice"/>
          </td>
        </tr>
        <tr v-if="showEngeOption">
          <td class="tableLabel">项目工程师</td>
          <td class="tdContent">
            <el-select v-model="productions.engeApproveId">
              <el-option
                  v-for="item in engeList"
                  :key="item.handler"
                  :label="item.handlerEmployeeName"
                  :value="item.handler"
                  @click.native="selectEnge(item)"
              />
            </el-select>
          </td>
        </tr>
        <tr v-if="showSalePrice">
          <td class="tableLabel">销售价格</td>
          <td class="tdContent" colspan="8">
            <el-input type="number" v-model="productions.salePrice" style="width: 120px;" :disabled="disableSalePrice"
                      @input="productions.salePrice = String(productions.salePrice).replace(/[^\d.]/g, '')"/>
          </td>
        </tr>
        <tr v-if="showSpecifiation">
          <td class="tableLabel">规格型号</td>
          <td class="tdContent" colspan="8" v-if="disableSpecification">{{ productions.materialSpecification }}</td>
          <td class="tdContent" colspan="8" v-else>
            <el-input v-model="productions.materialSpecification" style="width: 300px;"/>
          </td>
        </tr>
        <tr v-if="showOrderType">
          <td class="tableLabel">订单类型</td>
          <td class="tdContent" v-if="disableOrderType">
            <div>
              {{ constant.productOrderType[productions.orderType] }}
              {{ constant.productOrderStandard[productions.orderStandard] }}
            </div>
          </td>
          <td v-else>
            <el-select v-model="productions.orderType" style="width: 120px;">
              <el-option v-for="item in orderTypes" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
            <el-select v-model="productions.orderStandard" style="width: 100px;margin-left: 20px;">
              <el-option v-for="item in orderStandards" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </td>
          <td class="tableLabel">订单数量</td>
          <td class="tdContent" v-if="disableOrderType" colspan="5">
            <div>
              {{ productions.orderQty }}
            </div>
          </td>
          <td v-else colspan="5">
            <el-input type="number" v-model="productions.orderQty" style="width: 120px;"
                      @input="productions.orderQty = String(productions.orderQty).replace(/[^\d.]/g, '')"/>
          </td>
        </tr>
        <tr v-if="showMaterial">
          <td class="tableLabel">物料编号</td>
          <td class="tdContent" v-if="disableMaterial" colspan="8">
            {{ productions.materialNo }}
          </td>
          <td v-else colspan="8">
            <el-input v-model="productions.materialNo" style="width: 300px;"/>
          </td>
        </tr>
        <tr v-if="showBom">
          <td class="tableLabel">BOM编号</td>
          <td class="tdContent" v-if="disableBom">
            {{ productions.bomNo }}
          </td>
          <td v-else>
            <el-input v-model="productions.bomNo"/>
          </td>
          <td class="tableLabel">操作卡编号</td>
          <td class="tdContent" v-if="disableBom" colspan="5">
            {{ productions.esopNo }}
          </td>
          <td v-else colspan="5">
            <el-input v-model="productions.esopNo" style="width: 300px;"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
        style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
      技术参数(带*为必须填写项目)
    </div>
    <!--10-->
    <div v-if="showP10">
      <el-form ref="form"
               :model="p10"
               class="form"
               style="height: 450px;"
               label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="电流" prop="dianliu_10">
              <el-input v-model="p10.dianliu_10" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电压" prop="dianya_10">
              <el-input v-model="p10.dianya_10" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="*" prop="danxiang_10">
              <el-input v-model="p10.danxiang_10" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="尺寸" prop="chicun_10">
              <el-input v-model="p10.chicun_10" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户需求" prop="note_10">
              <el-input v-model="p10.note_10" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所" prop="changsuo_10">
              <el-input v-model="p10.changsuo_10" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p10.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p10.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p10.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p10.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p10.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <span style="margin-left: 20px;">{{ p10.optionBom ? '✓ 物料清单' : '✗ 物料清单' }}</span>-->
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p10.optionPrice" label="报价" readonly/>-->
            <!--            <el-checkbox v-model="p10.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p10.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p10.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p10.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--20-->
    <div v-if="showP20">
      <el-form ref="form"
               :model="p20"
               class="form"
               style="height: 200px;"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单相,三相/隔离,自耦" prop="danxiang_20">
              <el-input v-model="p20.danxiang_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="容量（功率）KW" prop="rongliang_20">
              <el-input v-model="p20.rongliang_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="初级电压（输入）" prop="chujidianya_20">
              <el-input v-model="p20.chujidianya_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="次级电压（输出）" prop="cijidianya_20">
              <el-input v-model="p20.cijidianya_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="初级额定电流(A)" prop="chujidianliu_20">
              <el-input v-model="p20.chujidianliu_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="次级额定电流(A)" prop="cijidianliu_20">
              <el-input v-model="p20.cijidianliu_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="基波频率(Hz)" prop="jiboHz_20">
              <el-input v-model="p20.jiboHz_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开关频率(KHz)" prop="kaiguanHz_20">
              <el-input v-model="p20.kaiguanHz_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="温升(K)" prop="wensheng_20">
              <el-input v-model="p20.wensheng_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="效率(%)" prop="xiaolv_20">
              <el-input v-model="p20.xiaolv_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导体材料(铜/铝）" prop="daoti_20">
              <el-input v-model="p20.daoti_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="尺寸要求" prop="chicun_20">
              <el-input v-model="p20.chicun_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其它" prop="note_20">
              <el-input type="textarea" v-model="p20.note_20" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        特殊要求(带*为必须填写项目)
      </div>
      <el-form ref="form"
               :model="p20"
               class="form"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="有无客户文件" prop="filename_20">
              <el-input v-model="p20.filename_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无测试要求" prop="test_20">
              <el-input v-model="p20.test_20" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无出口要求" prop="chukou_20">
              <el-input v-model="p20.chukou_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_20">
              <el-input v-model="p20.guozai_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexianpai_20">
              <el-input v-model="p20.jiexianpai_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_20">
              <el-input v-model="p20.demo_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_20">
              <el-input v-model="p20.changsuo_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_20">
              <el-input v-model="p20.fanghu_20" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p20.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p20.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p20.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p20.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p20.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p20.optionPrice" label="报价"/>-->
            <!--            <el-checkbox v-model="p20.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p20.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p20.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p20.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--30-->
    <div v-if="showP30">
      <el-form ref="form"
               :model="p30"
               class="form"
               style="height: 200px;"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单相/三相" prop="danxiang_30">
              <el-input v-model="p30.danxiang_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电感量(mH)" prop="diangan_30">
              <el-input v-model="p30.diangan_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电容容量（KVAR)" prop="dianrongrongliang_30">
              <el-input v-model="p30.dianrongrongliang_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="额定电流（A)" prop="dianliu_30">
              <el-input v-model="p30.dianliu_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系统工作电压（V）" prop="dianya_30">
              <el-input v-model="p30.dianya_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="温升（K)" prop="wensheng_30">
              <el-input v-model="p30.wensheng_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电容电压（V）" prop="dianrongdianya_30">
              <el-input v-model="p30.dianrongdianya_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="冷却方式" prop="lengque_30">
              <el-input v-model="p30.lengque_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电抗率（%）" prop="diankang_30">
              <el-input v-model="p30.diankang_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="噪音(dB)" prop="zaoyin_30">
              <el-input v-model="p30.zaoyin_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导体材料(铜/铝）" prop="daoti_30">
              <el-input v-model="p30.daoti_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="尺寸要求" prop="chicun_30">
              <el-input v-model="p30.chicun_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其它" prop="note_30">
              <el-input type="textarea" v-model="p30.note_30" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        特殊要求(带*为必须填写项目)
      </div>
      <el-form ref="form"
               :model="p30"
               class="form"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="有无客户文件" prop="filename_30">
              <el-input v-model="p30.filename_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无测试要求" prop="test_30">
              <el-input v-model="p30.test_30" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无出口要求" prop="chukou_30">
              <el-input v-model="p30.chukou_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_30">
              <el-input v-model="p30.guozai_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_30">
              <el-input v-model="p30.jiexian_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_30">
              <el-input v-model="p30.demo_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_30">
              <el-input v-model="p30.fanghu_30" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p30.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p30.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p30.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p30.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p30.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p30.optionPrice" label="报价"/>-->
            <!--            <el-checkbox v-model="p30.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p30.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p30.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p30.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--40-->
    <div v-if="showP40">
      <el-form ref="form"
               :model="p40"
               class="form"
               style="height: 200px;"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单相/三相" prop="danxiang_40">
              <el-input v-model="p40.danxiang_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系统工作电压（U)" prop="dianya_40">
              <el-input v-model="p40.dianya_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="功率（变频器KW）" prop="gonlv_40">
              <el-input v-model="p40.gonlv_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电感量(mH)" prop="diangan_40">
              <el-input v-model="p40.diangan_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="额定电流（A)" prop="dianliu_40">
              <el-input v-model="p40.dianliu_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="基波频率（Hz）" prop="jiboHz_40">
              <el-input v-model="p40.jiboHz_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="温升（K)" prop="wensheng_40">
              <el-input v-model="p40.wensheng_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导体材料(铜/铝）" prop="daoti_40">
              <el-input v-model="p40.daoti_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开关频率（KHz）" prop="kaiguanHz_40">
              <el-input v-model="p40.kaiguanHz_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="绝缘等级（H/F)" prop="jueyuan_40">
              <el-input v-model="p40.jueyuan_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="噪音(dB)" prop="zaoyin_40">
              <el-input v-model="p40.zaoyin_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="冷却方式" prop="lengque_40">
              <el-input v-model="p40.lengque_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="尺寸要求" prop="chicun_40">
              <el-input v-model="p40.chicun_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="连接方式" prop="lianjie_40">
              <el-input v-model="p40.lianjie_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其它" prop="note_40">
              <el-input type="textarea" v-model="p40.note_40" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        特殊要求(带*为必须填写项目)
      </div>
      <el-form ref="form"
               :model="p40"
               class="form"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="有无客户文件" prop="filename_40">
              <el-input v-model="p40.filename_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无测试要求" prop="test_40">
              <el-input v-model="p40.test_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无出口要求" prop="chukou_40">
              <el-input v-model="p40.chukou_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_40">
              <el-input v-model="p40.guozai_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_40">
              <el-input v-model="p40.jiexian_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_40">
              <el-input v-model="p40.demo_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_40">
              <el-input v-model="p40.changsuo_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_40">
              <el-input v-model="p40.fanghu_40" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p40.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p40.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p40.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p40.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p40.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p40.optionPrice" label="报价"/>-->
            <!--            <el-checkbox v-model="p40.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p40.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p40.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p40.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--50-->
    <div v-if="showP50">
      <el-form ref="form"
               :model="p50"
               class="form"
               label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="功率" prop="gonglv_50">
              <el-input v-model="p50.gonglv_50" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阻值" prop="zuzhi_50">
              <el-input v-model="p50.zuzhi_50" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="系统电压" prop="dianya_50">
              <el-input v-model="p50.dianya_50" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="耐压" prop="naiya_50">
              <el-input v-model="p50.naiya_50" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="认证要求" prop="renzheng_50">
              <el-input v-model="p50.renzheng_50" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height: 80px;">
          <el-col :span="24">
            <el-form-item label="电阻类型" prop="dianzuleixing_50">
              <el-input v-model="p50.dianzuleixing_50" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="箱体材质" prop="xiangti_50">
              <el-input v-model="p50.xiangti_50" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户需求" prop="note_50">
              <el-input type="textarea" v-model="p50.note_50" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所" prop="changsuo_50">
              <el-input type="textarea" v-model="p50.changsuo_50" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p50.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p50.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p50.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p50.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p50.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p50.optionPrice" label="报价"/>-->
            <!--            <el-checkbox v-model="p50.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p50.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p50.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p50.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--60-->
    <div v-if="showP60">
      <el-form ref="form"
               :model="p60"
               class="form"
               style="height: 200px;"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单相/三相" prop="danxiang_60">
              <el-input v-model="p60.danxiang_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系统工作电压（U)" prop="dianya_60">
              <el-input v-model="p60.dianya_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="功率（变频器KW）" prop="gonglv_60">
              <el-input v-model="p60.gonglv_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电感量(mH)" prop="diangan_60">
              <el-input v-model="p60.diangan_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="额定电流（A)" prop="dianliu_60">
              <el-input v-model="p60.dianliu_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="基波频率（Hz）" prop="jiboHz_60">
              <el-input v-model="p60.jiboHz_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="温升（K)" prop="wensheng_60">
              <el-input v-model="p60.wensheng_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导体材料(铜/铝）" prop="daoti_60">
              <el-input v-model="p60.daoti_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开关频率（KHz）" prop="kaiguanHz_60">
              <el-input v-model="p60.kaiguanHz_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="绝缘等级（H/F)" prop="jueyuan_60">
              <el-input v-model="p60.jueyuan_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="噪音(dB)" prop="zaoyin_60">
              <el-input v-model="p60.zaoyin_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="冷却方式" prop="lengque_60">
              <el-input v-model="p60.lengque_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="尺寸要求" prop="chicun_60">
              <el-input v-model="p60.chicun_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="其它" prop="note_60">
              <el-input type="textarea" v-model="p60.note_60" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        特殊要求(带*为必须填写项目)
      </div>
      <el-form ref="form"
               :model="p60"
               class="form"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="有无客户文件" prop="filename_60">
              <el-input v-model="p60.filename_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无测试要求" prop="test_60">
              <el-input v-model="p60.test_60" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无出口要求" prop="chukou_60">
              <el-input v-model="p60.chukou_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_60">
              <el-input v-model="p60.guozai_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_60">
              <el-input v-model="p60.jiexian_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_60">
              <el-input v-model="p60.demo_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_60">
              <el-input v-model="p60.changsuo_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_60">
              <el-input v-model="p60.fanghu_60" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p60.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p60.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p60.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p60.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p60.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
            <!--            <el-checkbox style="margin-left: 20px;" v-model="p60.optionPrice" label="报价"/>-->
            <!--            <el-checkbox v-model="p60.optionDemo" label="打样"/>-->
            <!--            <el-checkbox v-model="p60.optionSpecification" label="规格书"/>-->
            <!--            <el-checkbox v-model="p60.optionClient" label="承认书"/>-->
            <!--            <el-checkbox v-model="p60.optionBom" label="物料清单"/>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--70-->
    <div v-if="showP70">
      <el-form ref="form"
               :model="p70"
               class="form"
               style="height: 200px;"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单相/三相" prop="danxiang_70">
              <el-input v-model="p70.danxiang_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系统工作电压（U)" prop="dianya_70">
              <el-input v-model="p70.dianya_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="功率（变频器KW）" prop="gonlv_70">
              <el-input v-model="p70.gonlv_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电感量(mH)" prop="diangan_70">
              <el-input v-model="p70.diangan_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="额定电流（A)" prop="dianliu_70">
              <el-input v-model="p70.dianliu_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="基波频率（Hz）" prop="jiboHz_70">
              <el-input v-model="p70.jiboHz_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="温升（K)" prop="wensheng_70">
              <el-input v-model="p70.wensheng_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导体材料(铜/铝）" prop="daoti_70">
              <el-input v-model="p70.daoti_40" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开关频率（KHz）" prop="kaiguanHz_70">
              <el-input v-model="p70.kaiguanHz_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="绝缘等级（H/F)" prop="jueyuan_70">
              <el-input v-model="p70.jueyuan_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="噪音(dB)" prop="zaoyin_70">
              <el-input v-model="p70.zaoyin_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="冷却方式" prop="lengque_70">
              <el-input v-model="p70.lengque_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="尺寸要求" prop="chicun_70">
              <el-input v-model="p70.chicun_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="连接方式" prop="lianjie_70">
              <el-input v-model="p70.lianjie_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其它" prop="note_70">
              <el-input type="textarea" v-model="p70.note_70" readonly autosize/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        特殊要求(带*为必须填写项目)
      </div>
      <el-form ref="form"
               :model="p70"
               class="form"
               label-width="140px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="有无客户文件" prop="filename_70">
              <el-input v-model="p70.filename_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无测试要求" prop="test_70">
              <el-input v-model="p70.test_70" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无出口要求" prop="chukou_70">
              <el-input v-model="p70.chukou_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_70">
              <el-input v-model="p70.guozai_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_70">
              <el-input v-model="p70.jiexian_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_70">
              <el-input v-model="p70.demo_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_70">
              <el-input v-model="p70.changsuo_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_70">
              <el-input v-model="p70.fanghu_70" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span style="margin-left: 80px;">{{ p70.optionPrice ? "✓ 报价" : " 报价" }}</span>
            <span style="margin-left: 20px;">{{ p70.optionDemo ? "✓ 打样" : " 打样" }}</span>
            <span style="margin-left: 20px;">{{ p70.optionSpecification ? "✓ 规格书" : " 规格书" }}</span>
            <span style="margin-left: 20px;">{{ p70.optionClient ? "✓ 承认书" : " 承认书" }}</span>
            <span style="margin-left: 20px;">{{ p70.optionBom ? "✓ 物料清单" : " 物料清单" }}</span>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        附件
      </div>
      <upload-file
          ref="upload"
          :show-file-list="false"
          :auth-index="authIndex"
          style="text-align: right;margin-top: 2px;"
          @upload-success="uploadSuccess"/>
      <el-table border :data="productions.attachments">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="名称">
          <template slot-scope="scope">
            <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="left" label="创建人" width="100"/>
        <el-table-column prop="createTime" align="left" label="创建时间" width="140"/>
        <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.createTime"
                       @click="productions.attachments.splice(scope.$index, 1)">删除
            </el-button>
          </template>
        </el-table-column>
        <!--        <el-table-column v-if="showEngeUpload" label="操作" align="center" width="120" class-name="vm-table_operate">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="danger" :disabled="userId!==scope.row.creatorId"-->
        <!--                       @click="productions.attachments.splice(scope.$index, 1)">删除-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
import HandleDetail from "@/views/workFlow/HandleDetail";
import constant from "@/util/constant";
import UploadFile from "@/components/UploadFile";
import loginUtil from "@/util/loginUtil";

export default {
  name: "ProductionApplicationPreview",
  components: {HandleDetail, UploadFile},
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      authIndex: 624,
      billId: "",
      billType: "13",
      sequId: "",
      constant,
      nodeId: "",
      userId: 0,
      isHidden: false,
      showEngeOption: false,
      showSalePrice: false,
      disableSalePrice: false,
      showCostPrice: false,
      showEngeUpload: false,
      disableApplicationType: false,
      showOrderType: false,
      disableOrderType: true,
      showMaterial: false,
      disableMaterial: true,
      showBom: false,
      disableBom: true,
      showSpecifiation: false,
      disableSpecification: true,
      customerLevels: constant.toSelect(constant.customerLevel),
      orderTypes: constant.toSelect(constant.productOrderType),
      orderStandards: constant.toSelect(constant.productOrderStandard),
      disableCostPrice: false,
      engeList: [],
      subTypeList: [],
      showP10: false,
      showP20: false,
      showP30: false,
      showP40: false,
      showP50: false,
      showP60: false,
      showP70: false,
      p10: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        dianliu_10: "",
        dianya_10: "",
        danxiang_10: "",
        listDanxiang_10: [],
        chicun_10: "",
        listChicun_10: [],
        note_10: "",
        changsuo_10: "",
      },
      p20: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_20: "",
        rongliang_20: "",
        chujidianya_20: "",
        cijidianya_20: "",
        chujidianliu_20: "",
        cijidianliu_20: "",
        jiboHz_20: "",
        kaiguanHz_20: "",
        wensheng_20: "",
        xiaolv_20: "",
        daoti_20: "",
        chicun_20: "",
        note_20: "",
        filePath_20: "",
        filename_20: "",
        test_20: "",
        chukou_20: "",
        guozai_20: "",
        jiexianpai_20: "",
        demo_20: "",
        changsuo_20: "",
        fanghu_20: "",
      },
      p30: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_30: "",
        diangan_30: "",
        dianrongrongliang_30: "",
        dianliu_30: "",
        dianya_30: "",
        wensheng_30: "",
        dianrongdianya_30: "",
        lengque_30: "",
        diankang_30: "",
        zaoyin_30: "",
        daoti_30: "",
        chicun_30: "",
        note_30: "",
        filePath_30: "",
        filename_30: "",
        test_30: "",
        chukou_30: "",
        guozai_30: "",
        jiexian_30: "",
        demo_30: "",
        fanghu_30: "",
      },
      p40: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_40: "",
        dianya_40: "",
        gonlv_40: "",
        diangan_40: "",
        dianliu_40: "",
        jiboHz_40: "",
        wensheng_40: "",
        daoti_40: "",
        kaiguanHz_40: "",
        jueyuan_40: "",
        zaoyin_40: "",
        lengque_40: "",
        chicun_40: "",
        listLianjie_40: [],
        lianjie_40: "",
        note_40: "",
        filePath_40: "",
        filename_40: "",
        test_40: "",
        chukou_40: "",
        guozai_40: "",
        jiexian_40: "",
        demo_40: "",
        changsuo_40: "",
        fanghu_40: "",
      },
      p50: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        gonglv_50: "",
        zuzhi_50: "",
        dianya_50: "",
        naiya_50: "",
        renzheng_50: "",
        listRenzheng_50: [],
        renzhengNote_50: "",
        dianzuleixing_50: "",
        listDianzuleixing_50: [],
        dianzuleixingNote_50: "",
        xiangti_50: "",
        listXiangti_50: [],
        xiangtiNote_50: "",
        note_50: "",
        changsuo_50: "",
      },
      p60: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_60: "",
        dianya_60: "",
        gonglv_60: "",
        diangan_60: "",
        dianliu_60: "",
        jiboHz_60: "",
        wensheng_60: "",
        daoti_60: "",
        kaiguanHz_60: "",
        jueyuan_60: "",
        zaoyin_60: "",
        lengque_60: "",
        chicun_60: "",
        note_60: "",
        filePath_60: "",
        filename_60: "",
        test_60: "",
        chukou_60: "",
        guozai_60: "",
        jiexian_60: "",
        demo_60: "",
        changsuo_60: "",
        fanghu_60: "",
      },
      p70: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_70: "",
        dianya_70: "",
        gonlv_70: "",
        diangan_70: "",
        dianliu_70: "",
        jiboHz_70: "",
        wensheng_70: "",
        daoti_70: "",
        kaiguanHz_70: "",
        jueyuan_70: "",
        zaoyin_70: "",
        lengque_70: "",
        chicun_70: "",
        listLianjie_70: [],
        lianjie_70: "",
        note_70: "",
        filePath_70: "",
        filename_70: "",
        test_70: "",
        chukou_70: "",
        guozai_70: "",
        jiexian_70: "",
        demo_70: "",
        changsuo_70: "",
        fanghu_70: "",
      },
      productions: {
        productCategory: "",
        engeApproveId: 0,
        engeApproveTime: "",
        materialNo: "",
        materialName: "",
        materialSpecification: "",
        bomNo: "",
        esopNo: "",
        materialCost: 0,
        manualCost: 0,
        productCost: 0,
        solution: "",
        changeRemark: "",
        techResponse: "",
        salePrice: 0,
        applicationType: 20,
        applicationSubType: 10,
        materialTypeId: 0,
        materialTypeName: "",
        orderType: "",
        orderStandard: "",
        orderQty: 0,
        preOrderQty: 0,
        attachments: [],
        details: [],
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.query.billId) {
          this.billId = val.query.billId;
          this.billType = val.query.billType;
          this.sequId = val.query.sequId;
          this.userId = loginUtil.getUserId();
          this.getData(val.query.billId);
          this.getNodeValue();
        }
      },
    },
    params: {
      handler() {
        this.doApprove();
      },
    },
  },
  methods: {
    getData() {
      this.$emit("loading-status", {"loading": true});
      this.$http
          .get("basic", `productApplications/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.productions = resp.data;

            this.showP10 = false;
            this.showP20 = false;
            this.showP30 = false;
            this.showP40 = false;
            this.showP50 = false;
            this.showP60 = false;
            this.showP70 = false;
            if (this.productions.productCategory === 10) {
              this.showP10 = true;
            }
            if (this.productions.productCategory === 20) {
              this.showP20 = true;
            }
            if (this.productions.productCategory === 30) {
              this.showP30 = true;
            }
            if (this.productions.productCategory === 40) {
              this.showP40 = true;
            }
            if (this.productions.productCategory === 50) {
              this.showP50 = true;
            }
            if (this.productions.productCategory === 60) {
              this.showP60 = true;
            }
            if (this.productions.productCategory === 70) {
              this.showP70 = true;
            }

            if (this.productions.details) {
              this.p10 = Object.assign(this.p10, this.productions.details[0]);
              this.p20 = Object.assign(this.p20, this.productions.details[0]);
              this.p30 = Object.assign(this.p30, this.productions.details[0]);
              this.p40 = Object.assign(this.p40, this.productions.details[0]);
              this.p50 = Object.assign(this.p50, this.productions.details[0]);
              this.p60 = Object.assign(this.p60, this.productions.details[0]);
              this.p70 = Object.assign(this.p70, this.productions.details[0]);
            }

            this.subTypeList = [];
            if (this.productions.applicationSubType) {
              this.subTypeList.push(this.productions.applicationSubType);
            }

          });
    },

    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },

    getNodeValue() {
      let params = {
        billType: this.billType,
        billId: this.billId,
        sequId: this.sequId,
      };
      this.$http.get("basic", "applications/approve", params).then((resp) => {
        this.nodeId = resp.data.nodeId;
        console.log(this.nodeId);
        this.initNode();
        this.checkNode();
      });
    },

    initNode() {
      this.disableApplicationType = true;
      this.showEngeOption = false;
      this.showSalePrice = false;
      this.disableSalePrice = false;
      this.showCostPrice = false;
      this.showEngeOption = false;
      this.showEngeUpload = false;

      this.showOrderType = false;
      this.disableOrderType = true;
      this.showMaterial = false;
      this.disableMaterial = true;

      this.showSpecifiation = false;
      this.disableSpecification = true;

      this.showBom = false;
      this.disableBom = true;
    },

    checkNode() {
      //总经理审核
      if (this.nodeId == "FmGeneralApprove") {
        this.disableApplicationType = false;
      }
      if ("FmSellApprove" == this.nodeId) {
        this.disableCostPrice = true;
      }

      // //技术经理
      // if (this.nodeId == "FmTechManageApprove") {
      //   this.showEngeOption = true;
      //   this.getEngeList();
      // }
      if (this.nodeId == "Fmlbq"
          || this.nodeId == "Fmbyq"
          || this.nodeId == "Fmdkq"
          || this.nodeId == "Fmdz"
          || this.nodeId == "Fmdg"
          || this.nodeId == "Fmgy") {
        this.showEngeOption = true;
        this.getEngeList();
      }

      //业务
      if (this.nodeId == "FmSellApprove") {
        this.showSalePrice = true;
      }

      if (this.nodeId == "FmEngeApprove") {
        this.disableSpecification = false;
        this.showEngeUpload = true;
      } else {
        this.showEngeUpload = false;
      }

      //采购/项目工程师/业务
      if (this.nodeId == "FmPurchaseApprove" || this.nodeId == "FmEngeApprove" || this.nodeId == "FmSellApprove") {
        this.showCostPrice = true;
      }

      // //技术经理复审
      // if (this.nodeId == "FmTechManageApprove2") {
      //   this.showCostPrice = true;
      // }
      if (this.nodeId == "Fmlbq1"
          || this.nodeId == "Fmbyq1"
          || this.nodeId == "Fmdkq1"
          || this.nodeId == "Fmdz1"
          || this.nodeId == "Fmdg1"
          || this.nodeId == "Fmgy1") {
        this.showCostPrice = true;
      }
      //总经理复审
      if (this.nodeId == "FmGeneralApprove2") {
        this.showCostPrice = true;
        this.showSalePrice = true;
      }

      //业务回传
      if (this.nodeId == "FmSellApprove2") {
        this.disableOrderType = false;
        this.showSalePrice = true;
        this.disableSalePrice = true;
      }
      //文控审核
      if (this.nodeId == "FmFileManagerApprove") {
        this.disableMaterial = false;
      }
      //项目工程师建档
      if (this.nodeId == "FmEngeApprove2") {
        this.disableBom = false;
      }
      //技术经理审核bom
      if (this.nodeId == "FmTechManageApprove3") {
        this.disableBom = false;
      }

      if (["Fmlbq1", "Fmbyq1", "Fmdkq1", "Fmdz1", "Fmdg1", "Fmgy1", "FmEngeApprove", "FmSellApprove", "FmGeneralApprove2",
        "FmSellApprove2", "FmFileManagerApprove", "FmEngeApprove2", "FmTechManageApprove3"].includes(this.nodeId)) {
        this.showSpecifiation = true;
      }

      if (["FmSellApprove2", "FmFileManagerApprove", "FmEngeApprove2", "FmTechManageApprove3"].includes(this.nodeId)) {
        this.showOrderType = true;
      }

      if (["FmFileManagerApprove", "FmEngeApprove2", "FmTechManageApprove3"].includes(this.nodeId)) {
        this.showMaterial = true;
      }

      if (["FmEngeApprove2", "FmTechManageApprove3"].includes(this.nodeId)) {
        this.showBom = true;
      }
    },

    getEngeList() {
      this.$http
          .get("basic", "configs/wfId/" + this.billType)
          .then(resp => {
            this.engeList = resp.data;

            // this.$nextTick(() => {
            //   this.productions.engeApproveId = this.engeList[0].handler;
            //   this.productions.engeApproveName = this.engeList[0].handlerEmployeeName;
            // });
          });
    },

    selectEnge(item) {
      console.log(item);
      this.productions.engeApproveId = item.handler;
    },

    changeSubType() {
      this.productions.applicationSubType = "";
      if (this.subTypeList) {
        this.productions.applicationSubType = this.subTypeList.join(",");
      }
    },
    doApprove() {
      if (this.params.actionType === 0) {
        // if (this.nodeId == "FmTechManageApprove") {
        //   if (this.productions.engeApproveId == null || this.productions.engeApproveId === 0)
        //     return this.$message.error("项目工程师不可为空！！！");
        // }
        if (this.nodeId == "Fmlbq"
            || this.nodeId == "Fmbyq"
            || this.nodeId == "Fmdkq"
            || this.nodeId == "Fmdz"
            || this.nodeId == "Fmdg"
            || this.nodeId == "Fmgy"
        ) {
          if (this.productions.engeApproveId == null || this.productions.engeApproveId === 0)
            return this.$message.error("项目工程师不可为空！！！");
        }


      }

      let approveVar = "";
      //总经理审核
      if (this.nodeId == "FmGeneralApprove") {
        let varList = [];
        varList.push("ApplicationType#" + (this.productions.applicationType));
        varList.push("ProductCategory#" + (this.productions.productCategory));
        if (varList.length > 0) {
          approveVar = varList.join("|");
        }
        this.updateBill();
      }

      //技术经理审核
      // if (this.nodeId == "FmTechManageApprove") {
      //   let varList = [];
      //   varList.push("EngeApproveId#" + (this.productions.engeApproveId));
      //   if (varList.length > 0) {
      //     approveVar = varList.join("|");
      //   }
      //   this.updateBill();
      // }
      if (this.nodeId == "Fmlbq"
          || this.nodeId == "Fmbyq"
          || this.nodeId == "Fmdkq"
          || this.nodeId == "Fmdz"
          || this.nodeId == "Fmdg"
          || this.nodeId == "Fmgy") {
        let varList = [];
        varList.push("EngeApproveId#" + (this.productions.engeApproveId));
        if (varList.length > 0) {
          approveVar = varList.join("|");
        }
        this.updateBill();
      }

      //业务审核
      if (this.nodeId == "FmSellApprove") {
        let isPrice = "false";
        if (this.productions.salePrice >= this.productions.productCost) {
          isPrice = "true";
        }
        let varList = [];
        varList.push("IsPriceOk#" + isPrice);
        if (varList.length > 0) {
          approveVar = varList.join("|");
        }

        this.updateBill();
      }

      //业务回传审核
      if (this.nodeId == "FmSellApprove2") {
        let varList = [];
        if (this.productions.orderQty > 0) {
          varList.push("OrderType#10");
        } else {
          varList.push("OrderType#20");
        }

        if (varList.length > 0) {
          approveVar = varList.join("|");
        }
        this.updateBill();
      }

      if (["FmPurchaseApprove", "FmEngeApprove", "FmFileManagerApprove", "FmEngeApprove2", "FmGeneralApprove2", "FmTechManageApprove3"].includes(this.nodeId)) {
        this.updateBill();
      }


      let billParam = [];
      let params = {
        billId: parseInt(this.billId),
        billType: parseInt(this.billType),
        sequId: parseInt(this.sequId),
        actionType: this.params.actionType,
        approveNote: this.params.approveNote,
        untreadedFlowId: this.params.untreadedFlowId,
        transferTo: this.params.transferTo,
        approveVar: approveVar,
        billParam: JSON.stringify(billParam),
      };
      this.$emit("loading-status", {loading: true});
      this.$http
          .post("basic", "applications/doApprove", params)
          .then((resp) => {
            this.$emit("loading-status", {loading: false});
            if (resp.success) {
              this.$message.success("保存成功");
              // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              //   this.updateHandle();
              // }
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/ProductionApplication",
              });
            }
          })
          .catch(() => {

            this.$emit("loading-status", {loading: false});
          });
    },

    updateBill() {
      this.$http.post("basic", "productApplications/save/0", this.productions)
          .then(() => {
          })
          .catch(() => {
          });
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
          creatorId: loginUtil.getUserId(),
          creatorName: loginUtil.getName(),
        };
        this.productions.attachments.push(params);
      }
    },

  },
};
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
